import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageList = _resolveComponent("MessageList")!

  return (_openBlock(), _createBlock(_component_MessageList, {
    messages: _ctx.messages,
    loaded: _ctx.loaded
  }, null, 8, ["messages", "loaded"]))
}